import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useDefaultCustomerTypeId_session$key } from "./__generated__/useDefaultCustomerTypeId_session.graphql";

export const useDefaultCustomerTypeId = (
  sessionRef: useDefaultCustomerTypeId_session$key
) => {
  const session = useFragment(
    useDefaultCustomerTypeIdFragmentString,
    sessionRef
  );
  return session.currentClientProfile?.member?.club?.defaultCustomerType?.id;
};

const useDefaultCustomerTypeIdFragmentString = graphql`
  fragment useDefaultCustomerTypeId_session on Session {
    currentClientProfile {
      member {
        club {
          defaultCustomerType {
            id
          }
        }
      }
    }
  }
`;
